import * as types from './mutation-types'

export default {
    [types.GET_EMPLOYEE] (state, payload) {
        state.employee = payload
        state.showDialog = true
    }
}